import React from "react";
import ReactDOM from "react-dom/client";
import { ClerkProvider } from "@clerk/clerk-react";
import "./styles/index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { captureAttribution } from "./utils/attribution";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
// Imported for its side effect: starts capturing `beforeinstallprompt`, which
// can fire before React mounts (D-007).
import "./utils/pwaInstall";

// Run before React mounts so first-touch UTMs are stored before any sign-up
// or order flow reads them.
captureAttribution();

// WhoBrew brand theming for all Clerk UI (sign-in modal, user button, etc.).
// `variables` are always applied by Clerk; `elements` layer on a few brand
// touches via the app's Tailwind classes. Tokens mirror tailwind.config.js.
const clerkAppearance = {
  variables: {
    colorPrimary: "#b8521a",            // accent (terracotta)
    colorText: "#1f1410",               // coffee-900
    colorTextSecondary: "#6b4a36",      // coffee-600
    colorBackground: "#ffffff",
    colorInputBackground: "#ffffff",
    colorInputText: "#1f1410",
    colorDanger: "#963a2c",
    colorSuccess: "#5a7a3f",
    fontFamily: '"Inter", system-ui, -apple-system, sans-serif',
    borderRadius: "6px",
  },
  elements: {
    formButtonPrimary: "bg-accent-500 hover:bg-accent-600 normal-case",
    card: "shadow-coffee",
    headerTitle: "font-serif",
    footerActionLink: "text-accent-600 hover:text-accent-700",
  },
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <ClerkProvider
      publishableKey={process.env.REACT_APP_CLERK_PUBLISHABLE_KEY!}
      appearance={clerkAppearance}
    >
      <App />
    </ClerkProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Required for PWA installability: without a registered service worker Chrome
// never offers the native install prompt (D-007).
serviceWorkerRegistration.register();
